<template>
  <v-dialog v-model="dialog" persistent :width="fileSendSuccess ? 1800 : 450">
    <v-card v-if="status" class="border-white">
      <v-card-title class="justify-center color-white back-556C96">
        <h3>도면업로드</h3>
      </v-card-title>
      <v-card-text class="mt-3 ma-0 pa-0">
        <div class="d-flex flex-column  mb-4">
          <v-row class="ma-0 justify-center align-center mb-1">
            <h3>파일명</h3>
            <div @click="uploadFile">
              <input
                class="border-aaaaaa ml-3 mr-3 cursor-pointer height-20"
                placeholder="파일명"
                disabled
                v-model="filename"
              />
            </div>
            <input
              class="border-aaaaaa ml-3 mr-3 display"
              id="uploadfileUpLoad"
              type="file"
              accept=".dxf,.dwg"
              @change="changeFile"
              ref="file"
              value
            />
            <v-btn
              @click="uploadFile"
              width="100"
              height="38"
              color="#718FC7"
              class="color-white"
              >불러오기
            </v-btn>
          </v-row>

          <div class="d-flex align-center justify-end error-msg">
            {{ errMsg }}
          </div>
        </div>

        <v-row class="ma-0 pa-0 pl-5 align-center" v-if="errorStatus">
          <img src="/static/redcaution.svg" class="mr-2" />
          <h4 class="color-red" v-html="errorText"></h4>
        </v-row>
        <v-row class=" back-F7FAFF pa-5 mt-5 mb-5  ml-0 mr-0 ">
          <h4 v-html="cautionText"></h4>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          @click="uploadDrawing"
          width="130"
          height="38"
          color="#718FC7"
          class="color-white"
          :disabled="reloadStatus > 0 || errMsg.length > 0"
        >
          업로드</v-btn
        >
        <v-btn @click="dialog = false" width="130" height="38" color="#eeeeee">
          취소</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card v-else-if="!fileSendSuccess" class="border-white">
      <v-card-title class="justify-center color-white back-556C96">
        <h3>도면업로드</h3>
      </v-card-title>

      <v-card-text class="mt-3">
        <v-row class="ma-0 pa-0">
          {{ "파일명 " + filename }}
        </v-row>
        <v-row class="ma-0 pl-5">
          <h4>도면 데이터 업로드</h4>
        </v-row>
        <v-row class="ma-0 pl-5 pr-5">
          <v-progress-linear
            v-model="sendFile"
            color="#71D1FA"
            height="25"
            rounded
            class="width-85 mr-2"
          >
          </v-progress-linear>
          {{ Math.ceil(sendFile) + "%" }}
        </v-row>
        <v-row class="ma-0 pl-5">
          <h4>도면 데이터 분석</h4>
        </v-row>
        <v-row class="ma-0 pl-5 pr-5">
          <v-progress-linear
            v-model="readFile"
            color="amber"
            height="25"
            rounded
            class="width-85 mr-2"
          >
          </v-progress-linear>
          {{ Math.ceil(readFile) + "%" }}
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-else-if="fileSendSuccess" class="border-white">
      <v-card-title class="justify-center color-white back-556C96">
        <h3>도면업로드</h3>
      </v-card-title>
      <v-row class="justify-center ma-0">
        <v-simple-table height="160" class="ma-3" fixed-header>
          <thead>
            <tr class=" color-white text-center">
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96 pa-0"
                style="padding-left:30px !important; padding-right:30px !important;"
              >
                발주차수
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96 pl-5 pr-5"
                style="width:100px !important;padding-left:80px !important;padding-right:80px !important"
              >
                부위
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96 pa-0"
              >
                동
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96 pa-0"
              >
                층
              </th>
              <th rowspan="2" class="color-white text-center back-556C96 pa-0">
                부재
              </th>
              <th
                :colspan="materialLists.length"
                class="color-white text-center border-left-white back-556C96"
              >
                규격(단위:TON)
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-left-white back-556C96 "
              >
                발주수량
              </th>
            </tr>
            <tr>
              <th
                class="back-556C96 color-white text-center border-top-white border-left-white border-right-white"
                v-for="(list, i) in materialLists"
                :key="i"
              >
                {{ list }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center">
              <td>{{ uploadList.orderName }}</td>
              <td style="width:100px !important">{{ uploadList.partName }}</td>
              <td>{{ uploadList.dong }}</td>
              <td>{{ uploadList.floor }}</td>
              <td>{{ uploadList.type }}</td>
              <td v-for="(list, j) in materialLists" :key="(j + 2) * 100">
                {{ uploadList[list] }}
              </td>
              <td>{{ mathRound(uploadList.sum) }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-row class="ma-0 justify-center pr-5 pb-5">
        <v-btn
          @click="insertData"
          width="130"
          height="38"
          color="#FFFFFF"
          class="btn-739eec mr-4"
          style="border:1px solid #739eec;border-color:#739eec"
          >업로드
        </v-btn>
        <v-btn
          @click="backupload"
          width="130"
          height="38"
          color="#718FC7"
          class="color-white mr-4"
          >뒤로가기
        </v-btn>
        <v-btn @click="dialog = false" width="130" height="38" color="#EEEEEE"
          >취소
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import FileApi from "@/api/FileService";
import OrderApi from "@/api/OrderService";
import RebarService from "@/api/RebarService";
import Commonality from "@/mixin/Commonality";
export default {
  mixins: [Commonality],
  data: () => ({
    dialog: false,
    file: "",
    filename: "",
    orderId: null,
    reloadStatus: 0,
    sendFile: 0,
    readFile: 0,
    complete: false,
    status: true,
    fileSendSuccess: false,
    uploadList: [],
    fileRoute: "",
    errorStatus: false,
    errorText: "",
    standardList: [],
    materialLists: [],
    storeFile: "",
    errMsg: "",
  }),
  async created() {
    this.materialLists = this.materialList;
    let res = await RebarService.standardRebarList();
    this.standardList = res.data.list;
    this.$bus.$on("drawingUpload", (value) => {
      this.dialog = true;
      if (value) this.orderId = value;
    });
  },
  computed: {
    cautionText() {
      if (!this.orderId)
        return `주의
                        <img src="../static/caution.svg">
                        <br>
                        도면 업로드시,<br>
                        차수/부위/발주 수량 정보는 <span  class='color-red'>CH-철근발주입고</span> 레이어로 설정되어 있어야 합니다.<br>
                        도면은 <span class='color-red'>.dxf .dwg</span> 형태만 업로드가 가능합니다.`;
      else
        return `주의<img src="../static/caution.svg"><br>
                        도면 업로드시, <br>
                        도면은 <span class='color-red'>dxf dwg</span> 형태만 업로드가 가능합니다.`;
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.status = true;
        this.orderId = "";
        this.filename = "";
        this.file = "";
        this.reloadStatus = 0;
        this.errorStatus = false;
        this.fileSendSuccess = false;
        document.getElementById("uploadfileUpLoad").value = "";
        this.errMsg = "";
      }
    },
    fileSendSuccess(val) {
      if (!val && !this.status) {
        this.complete = true;
      }
    },
    complete(val) {
      if (val) {
        this.readFile = 0;
        this.sendFile = 0;
      }
    },
    readFile(val) {
      if (val == 100 && this.complete) {
        this.readFile = 0;
        this.sendFile = 0;
        this.complete = false;
      }
    },
  },

  methods: {
    uploadListReset() {
      for (let j = 0; j < this.materialList.length; j++) {
        this.uploadList[this.materialList[j].rebar_name] = 0;
      }
    },

    backupload() {
      this.file = "";
      this.status = true;
      this.fileSendSuccess = false;
      this.fileRoute = "";
      this.reloadStatus = 0;
      this.errorStatus = false;
      this.filename = "";
      setTimeout(() => {
        this.$refs.file.value = "";
      }, 100);
    },

    async uploadDrawing() {
      if (this.file.length < 1) {
        this.$bus.$emit("dialog", "파일 업로드 후 실행해주세요.");
        return;
      }
      try {
        let payload = await this.createPayloadForUploadDxf();
        this.storeFile = payload;
        let res;
        if (this.reloadStatus == 0) {
          this.reloadStatus += 1;

          try {
            this.status = false;
            this.testUpdate();
            res = await FileApi.uploadParsingCad(payload);
            if (res.data.success == "ok") {
              let remainList = {};
              let {
                orderName,
                partName,
                sum,
                동,
                층,
                VH,
                ...searchInfo
              } = res.data.flask;
              for (let i in res.data.flask) {
                if (i.includes("HD")) {
                  remainList[i] = res.data.flask[i];
                  delete searchInfo[i];
                }
              }
              let datas = Object.keys(remainList);
              this.materialLists = datas.sort();
              this.uploadListReset();
              for (let i = 0; i < datas.length; i++) {
                let tempNumber = 0;

                for (let j = 0; j < this.standardList.length; j++) {
                  if (this.standardList[j].rebarName == datas[i]) {
                    tempNumber++;
                    this.uploadList[this.standardList[j].rebarName] =
                      res.data.flask[datas[i]];
                  }
                }
                if (tempNumber == 0) {
                  this.$bus.$emit(
                    "dialog",
                    "자재 목록이 다릅니다. 확인 후 업로드해주세요"
                  );
                  this.status = true;
                  this.reloadStatus = 0;
                  this.complete = true;
                  this.fileSendSuccess = false;
                  return;
                }
              }
              this.fileSendSuccess = true;
              this.complete = true;
              this.uploadList.orderName = orderName;
              this.uploadList.sum = sum;
              this.uploadList.partName = partName;
              this.uploadList.dong = 동;
              this.uploadList.floor = 층;
              this.uploadList.searchInfo = JSON.stringify(searchInfo);
              this.uploadList.type = VH;
              this.fileRoute = res.data.filedir;
            } else {
              this.status = true;
              this.complete = true;
              this.reloadStatus = 0;
              this.errorStatusChange("");
            }
          } catch (error) {
            this.complete = true;
            this.reloadStatus = 0;
            this.errorStatusChange();
          }
          this.$bus.$emit("orderNavigationDuplicated");
          this.$bus.$emit("loadingEnd");
        }
      } catch (error) {
        this.complete = true;
        this.reloadStatus = 0;
        this.errorStatusChange("server");
        this.$bus.$emit("orderNavigationDuplicated");

        console.log(error);
      }
    },
    createPayloadForUploadDxf() {
      let formData = new FormData();
      formData.append(1, this.file[0]);
      if (this.orderId) formData.append("orderId", this.orderId);
      return formData;
    },
    uploadFile() {
      document.getElementById("uploadfileUpLoad").click();
    },
    errorStatusChange(val) {
      this.complete = true;
      if (val == "fileExtension")
        this.errorText = "dxf형식이 아닙니다. 다시 업로드를 시도해 주십시오.";
      else if (val == "noneLayer")
        this.errorText =
          '"CH-철근발주입고" 레이어가 포함되어 있지 않습니다.<br> 다시 업로드를 시도해 주십시오.';
      else if (val == "server")
        this.errorText =
          '"서버문제가 발생하였습니다.<br> 이 문제가 지속시 관리자에 연락바랍니다.';
      else this.errorText = "파일 확인후 다시 업로드를 시도해 주십시오.";
      this.errorStatus = true;
    },
    changeFile(e) {
      let name = e.target.files[0].name.substring(
        e.target.files[0].name.length - 3
      );
      if (!(name == "dxf" || name == "dwg")) {
        this.errorStatusChange("fileExtension");
        return;
      }
      this.errorStatus = false;
      this.file = e.target.files;
      if (this.file.length) this.filename = this.file[0].name;
      else this.filename = "";

      const fileName = e.target.files[0].name;
      const isRegExp = /\[|\]/;
      if (isRegExp.test(fileName)) {
        this.errMsg = `* 파일명에서 "[" 또는 "]"를 제거해주세요`;
        this.file = null;
        return;
      }
      this.errMsg = "";
    },
    testUpdate() {
      if (this.sendFile < 100) this.sendFile += 1;
      else if (this.readFile < 99) this.readFile += 1;
      else if (this.readFile == 100) {
        this.sendFile = 0;
        this.readFile = 0;
        return;
      }
      setTimeout(() => {
        if (!this.complete) this.testUpdate();
        else {
          this.sendFile = 100;
          this.readFile = 100;
          return;
        }
      }, 500);
    },
    async insertData() {
      this.$bus.$emit("loadingStart");
      let data = {
        orderData: [
          {
            constructionId: this.constructionId,
            orderName: this.uploadList.orderName,
            partName: this.uploadList.partName,
            dong: this.uploadList.dong,
            floor: this.uploadList.floor,
            type: this.uploadList.type,
            searchInfo: this.uploadList.searchInfo,
            rebarListData: [],
            orderId: this.orderId,
          },
        ],
      };
      for await (let i of this.materialList) {
        if (!this.materialLists.includes(i.rebar_name)) {
          data.orderData[0].rebarListData.push({
            rebarName: i.rebar_name,
            rebarValue: 0,
          });
        }
      }
      for await (let i of this.materialLists) {
        data.orderData[0].rebarListData.push({
          rebarName: i,
          rebarValue: this.uploadList[i],
        });
      }
      try {
        let res;
        if (this.orderId) {
          res = await OrderApi.orderUpdate(data.orderData[0]);
          if (res.data.success == "fail") {
            this.$bus.$emit("dialog", res.data.reason);
            this.dialog = false;
            this.$bus.$emit("loadingEnd");
            return;
          }
          this.$bus.$emit("loadingStart");
          res = await FileApi.cadUpload(this.storeFile);
          if (res.data.success == "ok") {
            this.$bus.$emit("dialog", "파일업로드가 완료되었습니다.");
            this.dialog = false;
            this.$bus.$emit("orderNavigationDuplicated");
            this.reloadStatus = 0;
            this.$bus.$emit("resetApproval");
          } else this.$bus.$emit("dialog", "파일업로드가 실패하였습니다.");
        } else {
          res = await OrderApi.orderCreate(data);
          if (res.data.success == "ok") {
            res = await FileApi.fileMoveCad({
              orderId: res.data.orderId[0],
              fileDir: this.fileRoute,
            });
            if (res.data.success == "fail") {
              this.$bus.$emit(
                "dialog",
                "데이터 업로드는 완료 되었으나 도면은 업로드에 실패하였습니다."
              );
              return;
            } else this.$bus.$emit("dialog", "도면 업로드가 완료되었습니다.");
            this.$bus.$emit("orderNavigationDuplicated");
          } else {
            this.$bus.$emit("dialog", res.data.reason);
          }
        }

        this.dialog = false;
        this.$bus.$emit("loadingEnd");
      } catch (error) {
        this.$bus.$emit("loadingEnd");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.border-white {
  border: 1px solid white;
  border-color: white;
}
.width-85 {
  width: 85%;
}
#uploadfileUpLoad {
  display: none;
}
.height-20 {
  height: 38px;
}
.error-msg {
  color: rgb(255, 32, 32);
  font-size: 12px;
  font-weight: 400;
  height: 18px;
  padding-right: 60px;
}
</style>
